<template>
<div class="app-wrapper">
  <div class="sidebar">
    <sidebar></sidebar>
  </div>
<!--  <div class="nav" >-->
<!--    <navbar></navbar>-->
<!--  </div>-->
  <div class="main">
<!--    缓存这里不使用keep-alive 的include或exclude-->
      <keep-alive >
        <router-view v-if="!$route.meta.hidden && !$route.meta.cache"></router-view>
      </keep-alive>

      <router-view v-if="$route.meta.hidden || $route.meta.cache"></router-view>

  </div>
</div>
</template>

<script>
  import Sidebar from './components/Sidebar'
  import Navbar from './components/Navbar'
  export default {
    name: "layout",
    components:{
      Sidebar,
      Navbar
    },
    computed:{
      // router
    }
  }
</script>

<style scoped>
  .app-wrapper {
    position: relative;
    height: 100vh;
    overflow: hidden;
    top: 0;
    /*background-color: #42b983;*/

  }
  .sidebar{
    width: 170px;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    overflow-y: auto;
  }
  .nav{
    height: 62px;
    line-height: 62px;
    position: absolute;
    top: 0;
    left: 170px;
    right: 0;
    /*background-color: #ffffff;*/
    border-bottom: 1px solid #eee;
  }
  .main{
    position: absolute;
    top: 0;
    left: 170px;
    right: 0;
    bottom: 0;
    overflow: auto;
    /*padding: 26px 24px ;*/
    /*padding-left: 20px;*/
    /*padding-left: 20px;*/
    /*background-color: #BCC1CC;*/
  }

</style>
